import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ZoomitIcon = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      fill={fill}
    >
      <defs>
        <path id="w3u63sr1ta" d="M0 0h12v12H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="bktqivlugb" fill="#fff"></mask>
        <path
          d="M5.788 5.25 3.197 8.19H9.73a.09.09 0 0 0 .019.003L8.381 9.75H0l2.437-2.779 1.51-1.721h1.841zm6.212-3L9.563 5.029 8.053 6.75H6.212l2.591-2.94H2.27a.091.091 0 0 0-.019-.003L3.619 2.25H12z"
          fill="#E4002B"
        />
      </g>
    </svg>
  );
};

ZoomitIcon.displayName = 'ZoomitIcon';
